/**
 * Some product options (notably ones auto-generated by the Bundles app) get their
 * option name baked in whatever language the Shopify Admin UI was set to at creation
 * time (e.g. "Ilość" instead of "Menge"), and that field is locked from editing on
 * bundle products. This patches the rendered <legend> text to the theme's own
 * locale-aware translation for the current storefront language.
 *
 * Configure fixes via `window.__optionNameFixes`, a map of the fieldset's
 * `data-option-name` value (the option name, handleized) to the replacement text,
 * e.g. { ilosc: "Menge" }. That map is rendered from Liquid so it already reflects
 * the visitor's current locale.
 */
(function () {
  var fixes = window.__optionNameFixes || {};
  var handles = Object.keys(fixes);
  if (!handles.length) return;

  function applyFixes(root) {
    handles.forEach(function (handle) {
      var fieldsets = (root || document).querySelectorAll('fieldset[data-option-name="' + handle + '"]');
      fieldsets.forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        if (!legend) return;

        // Only touch the leading text node so any nested elements (e.g. a
        // selected-value <span> some option layouts append) are preserved.
        var node = legend.firstChild;
        while (node && node.nodeType !== Node.TEXT_NODE) {
          node = node.nextSibling;
        }

        var newText = fixes[handle];
        if (node) {
          if (node.textContent.trim() !== newText) {
            node.textContent = newText;
          }
        } else {
          legend.insertBefore(document.createTextNode(newText), legend.firstChild);
        }
      });
    });
  }

  applyFixes(document);

  // Variant pickers can re-render (quick add, quick view, section re-renders in the
  // theme editor), so keep watching for new fieldsets rather than fixing once.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('fieldset[data-option-name]')) {
          applyFixes(node.parentNode || document);
        } else if (node.querySelector && node.querySelector('fieldset[data-option-name]')) {
          applyFixes(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
